module.exports = __webpack_public_path__ + "img/workbench_icon6.6fe232c0.svg";